import { isObjectArrayWithNesting, JsonFormsRendererRegistryEntry, rankWith } from '@jsonforms/core';
import controlRenderer from './ArrayLayoutRenderer.vue';

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: controlRenderer,
  tester: rankWith(4, isObjectArrayWithNesting),
};
